import { useEffect, useState } from 'react';

import type { AgentChatActivityEvent } from '@/services/agents/chat-stream';

import { ThinkingRow, progressLabel, thinkingTail } from './thinking-row';

interface TurnProgressProps {
  events: AgentChatActivityEvent[];
  startedAt?: number;
  thinking?: string;
}

export function TurnProgress({
  events,
  startedAt,
  thinking,
}: TurnProgressProps) {
  const [elapsed, setElapsed] = useState(() =>
    startedAt ? Math.max(0, Math.round((Date.now() - startedAt) / 1000)) : 0,
  );

  useEffect(() => {
    if (!startedAt) return;
    const tick = () =>
      setElapsed(Math.max(0, Math.round((Date.now() - startedAt) / 1000)));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [startedAt]);

  return (
    <span data-testid='turn-progress' className='flex min-w-0 flex-col gap-1'>
      <span className='inline-flex items-center gap-2'>
        <ThinkingRow
          label={progressLabel(events)}
          elapsedSeconds={startedAt !== undefined ? elapsed : undefined}
        />
      </span>
      {/* Only turns with no events reach this row. In the unified chat that
          is the round trip before the first status frame, which carries no
          thinking; for a paused node's review the thinking is the reply in
          progress, so it stays visible. Steps and thinking that are details
          live in the activity feed, collapsed. */}
      {thinking && (
        <span
          data-testid='turn-progress-thinking'
          className='text-xs italic text-muted-foreground [overflow-wrap:anywhere]'
        >
          {thinkingTail(thinking)}
        </span>
      )}
    </span>
  );
}
